"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThirdCurrentStep = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const atome_1 = require("../../../components/atome");
const Folgerezept_1 = require("../../../components/pages/Profile/Folgerezept");
const Breakpoints_1 = require("../../../helper/Breakpoints");
const GlobalStyles_1 = require("../../../helper/GlobalStyles");
const Dashboard_web_style_1 = require("./Dashboard.web.style");
const ThirdCurrentStep = (props) => {
    const { userInformation, scrollToAktuel, navigateTo, onlineAppointmentCheckAndRedirect, setShowFolgerezept, } = props;
    return (react_1.default.createElement(react_native_1.View, { onLayout: event => {
            const layout = event.nativeEvent.layout;
            scrollToAktuel(layout.x, layout.y, layout.width, layout.height / 2, !Breakpoints_1.isMobileOrTablet ? true : false);
        } },
        react_1.default.createElement(atome_1.Text, { style: [
                Dashboard_web_style_1.styles.heading3,
                !Breakpoints_1.isMobileOrTablet ? {} : GlobalStyles_1.globalStyles.marginTop50,
            ] }, "Videosprechstunde buchen"),
        react_1.default.createElement(atome_1.Text, { style: [Dashboard_web_style_1.styles.text, Breakpoints_1.isMobileOrTablet ? {} : GlobalStyles_1.globalStyles.marginTop25] }, "Buchen Sie jetzt Ihre Videosprechstunde."),
        react_1.default.createElement(atome_1.Text, { style: [
                Dashboard_web_style_1.styles.text,
                !Breakpoints_1.isMobileOrTablet
                    ? GlobalStyles_1.globalStyles.marginTop5
                    : GlobalStyles_1.globalStyles.marginTop25,
                !Breakpoints_1.isMobileOrTablet ? {} : Dashboard_web_style_1.styles.paddingHorizontal4pct,
            ] }, "Planen Sie ausreichend Zeit f\u00FCr Bearbeitung und Rezeptversand ein."),
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.TouchableOpacity, { style: [
                    Dashboard_web_style_1.styles.button,
                    !Breakpoints_1.isMobileOrTablet
                        ? GlobalStyles_1.globalStyles.marginTop25
                        : GlobalStyles_1.globalStyles.marginTop50,
                ], onPress: onlineAppointmentCheckAndRedirect },
                react_1.default.createElement(atome_1.Text, { style: [Dashboard_web_style_1.styles.buttonText] }, "Jetzt Termin buchen")),
            userInformation?.medication?.length > 0 && (react_1.default.createElement(react_native_1.View, null,
                react_1.default.createElement(Folgerezept_1.Folgerezept, { userInformation: userInformation, setShowFolgerezept: setShowFolgerezept, navigateTo: navigateTo }))))));
};
exports.ThirdCurrentStep = ThirdCurrentStep;
